export function clearSectionsAction() {
  const { t } = useI18n();
  const viewerSectionsStore = useViewerSectionsStore();

  return {
    getTitle: () => t('components.xeokit_viewer.context_menu.clear_slices') || 'Clear Slices',
    getEnabled: () => viewerSectionsStore.numberOfSections > 0,
    doAction: () => viewerSectionsStore.clearSections(),
  };
}
